module.exports = __webpack_public_path__ + "static/media/1677512338458-Kariuki_Ngari.8eb8a979.jpg";